import { useState, useEffect, useRef } from "react";
import {
  fetchGiftList, fetchGiftDetail, createGift,
  updateGift, deleteGift, fetchGiftApplyList
} from "../api/giftApi";
import Toast from "../components/Toast";
import { getCodeList } from "../api/codeApi";

// ===================== 상세/등록 페이지 =====================
const DetailPage = ({ item, onBack, onSave, onDelete, isNew }) => {
  const [form, setForm] = useState({
    gift_year : new Date().getFullYear().toString(),
    gift_name : "",
    img_data  : null,
    opt_cnt   : 1,
    use_yn    : "Y",
    options   : [""],
  });
  const [preview,     setPreview]     = useState(null);
  const [applyList,   setApplyList]   = useState([]);
  const [applyLoading,setApplyLoading]= useState(false);
  const [optFilter,   setOptFilter] = useState('');
  const [toast,       setToast]       = useState("");
  const [tab,         setTab]         = useState("info"); // info | apply
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const fileRef = useRef(null);
  

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  useEffect(() => {
    if (item) {
      setForm({
        gift_year : item.gift_year,
        gift_name : item.gift_name,
        img_data  : item.img_data,
        opt_cnt   : item.opt_cnt,
        use_yn    : item.use_yn,
        options   : item.options?.map(o => o.opt_name) || Array(item.opt_cnt).fill(""),
      });
      setPreview(item.img_data);
    }
  }, [item]);

  // 옵션 수 변경 시 options 배열 조정
  const handleOptCntChange = (cnt) => {
    const newCnt = Number(cnt);
    const newOpts = Array(newCnt).fill("").map((_, i) => form.options[i] || "");
    set('opt_cnt', newCnt);
    set('options', newOpts);
  };

  // 이미지 업로드
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 1024 * 1024) {
      showToast('❌ 이미지 크기는 1MB 이하여야 합니다.');
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      set('img_data', ev.target.result);
      setPreview(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  // 신청 현황 로드
  const loadApplyList = async () => {
    if (!item) return;
    setApplyLoading(true);
    try {
      const res = await fetchGiftApplyList(item.gift_year, item.seq_no);
      if (res.success) setApplyList(res.data);
    } catch (err) { showToast('❌ 신청현황 조회 실패'); }
    finally { setApplyLoading(false); }
  };

  useEffect(() => {
    if (tab === 'apply') loadApplyList();
  }, [tab]);

  // 엑셀 다운로드
  const handleApplyExcelDownload = () => {
    import("xlsx").then((XLSX) => {
      const headers = ["소속", "부서", "직종", "사번", "이름", "연락처", "선택옵션", "신청일자"];
      const rows = applyList.map(r => [
        r.division_sub_name || '-', r.department || '-', r.job_name || '-',
        r.emp_no, r.name, r.phone || '-', r.opt_name || '-', r.apply_dt
      ]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      ws['!cols'] = [{ wch:16},{wch:16},{wch:14},{wch:12},{wch:12},{wch:16},{wch:16},{wch:20}];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '신청현황');
      XLSX.writeFile(wb, `선물신청현황_${form.gift_name}.xlsx`);
    });
  };

  // handleSubmit 함수 추가 (set 함수 아래)
  const handleSubmit = async () => {
    if (!item) { onSave(form); return; }
    try {
        const res = await fetchGiftApplyList(item.gift_year, item.seq_no);
        if (res.success && res.data.length > 0) {
        showToast(`❌ 신청자 ${res.data.length}명이 있어 수정할 수 없습니다.`);
        return;
        }
        onSave(form);
    } catch (err) {
        showToast('❌ 신청 현황 확인 실패');
    }
  };

  // 선물 삭제
  const handleDelete = async () => {
    try {
        const res = await fetchGiftApplyList(item.gift_year, item.seq_no);
        if (res.success && res.data.length > 0) {
        showToast(`❌ 신청자 ${res.data.length}명이 있어 삭제할 수 없습니다.`);
        return;
        }
        setShowDeleteModal(true);  // ← confirm 대신 모달
    } catch (err) {
        showToast('❌ 삭제 실패');
    }
  };

  const confirmDelete = async () => {
    try {
        const delRes = await deleteGift(item.gift_year, item.seq_no);
        if (delRes.success) {
        showToast('✅ 삭제되었습니다.');
        setShowDeleteModal(false);
        onDelete();  // ← onBack() 대신 onDelete() 호출
        } else showToast(`❌ ${delRes.message}`);
    } catch (err) {
        showToast('❌ 삭제 실패');
    } finally {
        setShowDeleteModal(false);
    }
  };

  // 마감 / 마감해제 
  const handleToggleUseYn = async () => {
    const newVal = form.use_yn === 'Y' ? 'N' : 'Y';
    const label  = newVal === 'N' ? '마감' : '마감해제';
    try {
        const res = await updateGift(item.gift_year, item.seq_no, { ...form, use_yn: newVal });
        if (res.success) {
        set('use_yn', newVal);
        showToast(`✅ ${label} 처리되었습니다.`);
        } else showToast(`❌ ${res.message}`);
    } catch (err) {
        showToast(`❌ ${label} 처리 실패`);
    }
  };

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />
      <button style={styles.backBtn} onClick={onBack}>← 목록으로</button>
      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>{isNew ? "🎁 선물 등록" : "🎁 선물 상세"}</h1>
      </div>

      {/* 탭 */}
      {!isNew && (
        <div style={{ display: "flex", gap: 4, marginBottom: 16 }}>
          {[{ key: "info", label: "기본정보" }, { key: "apply", label: "신청현황" }].map(t => (
            <button key={t.key}
              style={{ ...styles.tabBtn, ...(tab === t.key ? styles.tabBtnActive : {}) }}
              onClick={() => setTab(t.key)}>{t.label}</button>
          ))}
        </div>
      )}

      {tab === "info" ? (
        <div style={{ ...styles.card, padding: 32 }}>
          <div style={detailStyles.grid}>
            {/* 연도 */}
            <div style={detailStyles.field}>
              <label style={detailStyles.label}>연도 <span style={{ color: "#ff4d4f" }}>*</span></label>
              {isNew
                ? <input style={detailStyles.input} value={form.gift_year}
                    onChange={e => set('gift_year', e.target.value)} placeholder="예) 2026" maxLength={4} />
                : <input style={{ ...detailStyles.input, background: "#f5f5f5", color: "#aaa" }}
                    value={form.gift_year} disabled />
              }
            </div>

            {/* 선물명 */}
            <div style={detailStyles.field}>
              <label style={detailStyles.label}>선물명 <span style={{ color: "#ff4d4f" }}>*</span></label>
              <input style={detailStyles.input} value={form.gift_name}
                onChange={e => set('gift_name', e.target.value)} placeholder="선물명 입력" />
            </div>

            {/* 옵션 수 */}
            <div style={detailStyles.field}>
              <label style={detailStyles.label}>옵션 수</label>
              <input style={detailStyles.input} type="number" min={1} max={10}
                value={form.opt_cnt}
                onChange={e => handleOptCntChange(e.target.value)} />
            </div>

            {/* 진행여부 */}
            <div style={detailStyles.field}>
              <label style={detailStyles.label}>진행여부</label>
              <select style={detailStyles.input} value={form.use_yn}
                onChange={e => set('use_yn', e.target.value)}>
                <option value="Y">진행중</option>
                <option value="N">마감</option>
              </select>
            </div>
          </div>

          {/* 옵션명 */}
          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#1677ff", borderLeft: "3px solid #1677ff", paddingLeft: 10, marginBottom: 12 }}>
              옵션 관리
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {Array(form.opt_cnt).fill(null).map((_, i) => (
                <div key={i} style={detailStyles.field}>
                  <label style={detailStyles.label}>옵션 {i + 1}</label>
                  <input style={detailStyles.input}
                    value={form.options[i] || ""}
                    onChange={e => {
                      const newOpts = [...form.options];
                      newOpts[i] = e.target.value;
                      set('options', newOpts);
                    }}
                    placeholder={`옵션 ${i + 1} 이름 입력`} />
                </div>
              ))}
            </div>
          </div>

          {/* 이미지 업로드 */}
          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#1677ff", borderLeft: "3px solid #1677ff", paddingLeft: 10, marginBottom: 12 }}>
              이미지 (1MB 이하)
            </div>
            <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
              {/* 미리보기 */}
              <div style={{ width: 200, height: 200, border: "2px dashed #e0e0e0", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", background: "#fafafa", flexShrink: 0 }}>
                {preview
                  ? <img src={preview} alt="선물 이미지" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  : <span style={{ fontSize: 13, color: "#bbb" }}>이미지 없음</span>
                }
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <input type="file" accept="image/*" ref={fileRef} style={{ display: "none" }} onChange={handleImageUpload} />
                <button
                  style={{ background: "#fff", border: "1.5px solid #1677ff", color: "#1677ff", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
                  onClick={() => fileRef.current.click()}>
                  🖼️ 이미지 선택
                </button>
                {preview && (
                  <button
                    style={{ background: "#fff2f0", border: "1.5px solid #ff4d4f", color: "#ff4d4f", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
                    onClick={() => { set('img_data', null); setPreview(null); }}>
                    🗑 이미지 제거
                  </button>
                )}
                <span style={{ fontSize: 12, color: "#aaa" }}>JPG, PNG, GIF 지원 / 최대 1MB</span>
              </div>
            </div>
          </div>

          {/* 버튼 */}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 32, paddingTop: 20, borderTop: "1px solid #f0f0f0" }}>
            {!isNew && (
                <button style={styles.deleteBtn} onClick={handleDelete}>
                🗑 삭제
                </button>
            )}
            {!isNew && (
                <button
                style={{
                    background: "#fff",
                    border: `1.5px solid ${form.use_yn === 'Y' ? "#fa8c16" : "#52c41a"}`,
                    color: form.use_yn === 'Y' ? "#fa8c16" : "#52c41a",
                    borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer"
                }}
                onClick={handleToggleUseYn}>
                {form.use_yn === 'Y' ? '🔒 마감' : '🔓 마감해제'}
                </button>
            )}
            <button style={styles.editBtn} onClick={handleSubmit}>
                {isNew ? "✅ 등록" : "✏️ 수정"}
            </button>
          </div>
        </div>
      ) : (
        // 신청현황 탭
        <div style={styles.card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", borderBottom: "1px solid #f0f0f0" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: "#1a1a2e" }}>
                신청현황 <span style={{ color: "#1677ff" }}>{applyList.length}명</span>
                </span>
                {/* 옵션 필터 */}
                <select
                    style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "6px 12px", fontSize: 13, outline: "none", background: "#fff", cursor: "pointer" }}
                    value={optFilter}
                    onChange={e => setOptFilter(e.target.value)}>
                    <option value="">전체 옵션</option>
                    {form.options?.map((opt, i) => (
                        <option key={i} value={opt}>{opt}</option>
                    ))}
                </select>
            </div>
            <button
                style={{ background: "#fff", border: "1.5px solid #52c41a", color: "#52c41a", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
                onClick={handleApplyExcelDownload}>
                📊 엑셀 다운로드
            </button>
            </div>
            <div style={{ overflowX: "auto" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1.5fr 1.2fr 1fr 1.2fr 1.5fr 1.5fr 1.8fr", padding: "10px 20px", background: "#f8faff", borderBottom: "1px solid #e8f0fe", minWidth: 900 }}>
                {["소속", "부서", "직종", "사번", "이름", "연락처", "선택옵션", "신청일자"].map(h => (
                <div key={h} style={{ fontSize: 12, fontWeight: 700, color: "#888" }}>{h}</div>
                ))}
            </div>
            {(() => {
                const filtered = optFilter
                ? applyList.filter(r => r.opt_name === optFilter)
                : applyList;
                return applyLoading ? (
                <div style={styles.empty}>⏳ 불러오는 중...</div>
                ) : filtered.length === 0 ? (
                <div style={styles.empty}>신청자가 없습니다.</div>
                ) : filtered.map((r, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "1.5fr 1.5fr 1.2fr 1fr 1.2fr 1.5fr 1.5fr 1.8fr", padding: "12px 20px", borderBottom: "1px solid #f5f5f5", alignItems: "center", minWidth: 900 }}>
                    <div style={{ fontSize: 13 }}>{r.division_sub_name || '-'}</div>
                    <div style={{ fontSize: 13 }}>{r.department || '-'}</div>
                    <div style={{ fontSize: 13 }}>{r.job_name || '-'}</div>
                    <div style={{ fontSize: 13 }}>{r.emp_no}</div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{r.name}</div>
                    <div style={{ fontSize: 13, color: "#888" }}>{r.phone || '-'}</div>
                    <div style={{ fontSize: 13, color: "#1677ff", fontWeight: 600 }}>{r.opt_name || '-'}</div>
                    <div style={{ fontSize: 12, color: "#aaa" }}>{r.apply_dt}</div>
                </div>
                ));
            })()}
            </div>
        </div>
      )}

      {showDeleteModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 380, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", padding: "40px 28px 28px", textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 10px" }}>선물을 삭제하시겠습니까?</h3>
            <p style={{ fontSize: 13, color: "#999", margin: "0 0 28px" }}>삭제된 데이터는 복구할 수 없습니다.</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                <button
                style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 24px", fontSize: 14, color: "#666", cursor: "pointer", fontWeight: 600 }}
                onClick={() => setShowDeleteModal(false)}>
                취소
                </button>
                <button
                style={{ background: "#ff4d4f", border: "none", borderRadius: 8, padding: "10px 24px", fontSize: 14, color: "#fff", cursor: "pointer", fontWeight: 700 }}
                onClick={confirmDelete}>
                삭제
                </button>
            </div>
            </div>
        </div>
      )}
    </div>
  );
};

// ===================== 목록 페이지 =====================
export default function GiftPage({ onLogout }) {
  const [page,       setPage]       = useState('list');
  const [list,       setList]       = useState([]);
  const [selected,   setSelected]   = useState(null);
  const [isNew,      setIsNew]      = useState(false);
  const [loading,    setLoading]    = useState(false);
  const [toast,      setToast]      = useState('');
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear().toString());
  const [yearList, setYearList] = useState([]);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  const loadList = async (year) => {
    setLoading(true);
    try {
      const res = await fetchGiftList(year);
      if (res.success) setList(res.data);
      else if (res.message === '토큰이 만료되었습니다. 다시 로그인해주세요.') onLogout();
    } catch (err) { showToast('❌ 목록 조회 실패'); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadList(yearFilter); }, [yearFilter]);
  useEffect(() => {
    setYearList(getCodeList('YEAR_LIST'));
  }, []);

  const handleSave = async (form) => {
    try {
      const res = isNew
        ? await createGift(form)
        : await updateGift(selected.gift_year, selected.seq_no, form);
      if (res.success) {
        loadList(yearFilter); setPage('list');
        showToast(isNew ? '✅ 등록되었습니다.' : '✅ 수정되었습니다.');
      } else showToast(`❌ ${res.message}`);
    } catch (err) { showToast('❌ 저장 실패'); }
  };

  const loadDetail = async (item) => {
    try {
      const res = await fetchGiftDetail(item.gift_year, item.seq_no);
      if (res.success) { setSelected(res.data); setIsNew(false); setPage('detail'); }
      else showToast(`❌ ${res.message}`);
    } catch (err) { showToast('❌ 상세 조회 실패'); }
  };

  if (page === 'detail') {
    return (
      <>
        <Toast msg={toast} />
        <DetailPage
            item={selected}
            onBack={() => setPage('list')}
            onSave={handleSave}
            onDelete={() => { loadList(yearFilter); setPage('list'); }}  // ← 추가
            isNew={isNew}
        />
      </>
    );
  }

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />
      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>🎁 선물 관리</h1>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select style={styles.select} value={yearFilter}
            onChange={e => setYearFilter(e.target.value)}>
            <option value="">전체 연도</option>
            {yearList.map(y => (
              <option key={y.code} value={y.code}>{y.code_nm}</option>
            ))}
          </select>
          <button style={styles.registerBtn}
            onClick={() => { setSelected(null); setIsNew(true); setPage('detail'); }}>
            ＋ 선물 등록
          </button>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.tableHeader}>
            {["연번", "선물명", "옵션수", "신청수", "진행여부"].map(h => (
            <div key={h} style={styles.th}>{h}</div>
            ))}
        </div>
        {loading ? (
          <div style={styles.empty}>⏳ 불러오는 중...</div>
        ) : list.length === 0 ? (
          <div style={styles.empty}>등록된 선물이 없습니다.</div>
        ) : list.map((item, i) => (
          <div key={i} style={styles.tableRow}>
          <div style={styles.td}>{item.seq_no}</div>
          <div style={{ ...styles.td, fontWeight: 600, cursor: "pointer", color: "#1677ff" }}
                onClick={() => loadDetail(item)}>{item.gift_name}</div>
          <div style={styles.td}>{item.opt_cnt}개</div>
          <div style={styles.td}>{item.apply_cnt}명</div>
          <div style={styles.td}>
            <span style={{ color: item.use_yn === 'Y' ? "#52c41a" : "#ff4d4f", fontWeight: 600 }}>
            {item.use_yn === 'Y' ? '진행중' : '마감'}
            </span>
          </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrap        : { background: "#f5f7fa", padding: 24, fontFamily: "'Noto Sans KR', sans-serif" },
  pageHeader  : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  pageTitle   : { fontSize: 22, fontWeight: 800, color: "#1a1a2e", margin: 0 },
  select      : { border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 14, outline: "none", background: "#fff", cursor: "pointer" },
  registerBtn : { background: "linear-gradient(135deg, #1677ff, #4096ff)", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 14, fontWeight: 700, cursor: "pointer" },
  card        : { background: "#fff", borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden" },
  tableHeader : { display: "grid", gridTemplateColumns: "0.5fr 2fr 0.8fr 0.8fr 0.8fr", padding: "12px 20px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" },
  th          : { fontSize: 12, fontWeight: 700, color: "#888" },
  tableRow    : { display: "grid", gridTemplateColumns: "0.5fr 2fr 0.8fr 0.8fr 0.8fr", padding: "14px 20px", borderBottom: "1px solid #f5f5f5", alignItems: "center" },
  td          : { fontSize: 14, color: "#1a1a2e", display: "flex", alignItems: "center" },
  empty       : { textAlign: "center", padding: "60px 0", color: "#bbb", fontSize: 14 },
  backBtn     : { background: "none", border: "1px solid #e0e0e0", borderRadius: 8, padding: "8px 14px", fontSize: 13, color: "#666", cursor: "pointer", marginBottom: 12, display: "block" },
  editBtn     : { background: "#fff", border: "1.5px solid #1677ff", color: "#1677ff", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
  smDelBtn    : { background: "#fff2f0", border: "1px solid #ffccc7", color: "#ff4d4f", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" },
  tabBtn      : { background: "#fff", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 20px", fontSize: 14, fontWeight: 500, color: "#666", cursor: "pointer" },
  tabBtnActive: { background: "#e8f4fd", border: "1.5px solid #1677ff", color: "#1677ff", fontWeight: 700 },
  deleteBtn : { background: "#fff2f0", border: "1.5px solid #ff4d4f", color: "#ff4d4f", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
};

const detailStyles = {
  grid  : { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  field : { display: "flex", flexDirection: "row", alignItems: "center", gap: 0, background: "#fafafa", borderRadius: 8, border: "1.5px solid #e0e0e0", overflow: "hidden" },
  label : { fontSize: 13, fontWeight: 600, color: "#666", background: "#f0f4ff", padding: "12px 16px", minWidth: 100, whiteSpace: "nowrap", borderRight: "1.5px solid #e0e0e0" },
  input : { border: "none", borderRadius: 0, padding: "12px 16px", fontSize: 14, outline: "none", background: "transparent", color: "#1a1a2e", width: "100%", boxSizing: "border-box" },
};